import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, EventEmitter, Input, Output, QueryList, signal, ViewChildren } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { faCircleCheck, faSend } from '@fortawesome/pro-regular-svg-icons';

import { Comment } from '@empathy/comments/data';

import { HashtagComponent } from '../hashtag/hashtag.component';

@Component({
  selector: 'empathy-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss'],
  animations: [
    trigger('cardAnimation', [
      state('void', style({ opacity: 0, transform: 'translateY(-2%)' })),
      state('*', style({ opacity: 1 })),
      transition(':enter', [animate('150ms cubic-bezier(.17,.67,1,1.04)', style({ opacity: 1, transform: 'translateY(0)' }))]),
      transition(':leave', [animate('150ms cubic-bezier(.17,.67,1,1.04)', style({ opacity: 0, transform: 'translateX(100%)', height: 0 }))])
    ])
  ]
})
export class CommentComponent {
  @ViewChildren(HashtagComponent) hashtags: QueryList<HashtagComponent>;

  @Input() readonly: boolean;

  @Output() emitHashtag = new EventEmitter<string>();
  @Output() saveChangesComment = new EventEmitter<Comment>();
  @Output() postComment = new EventEmitter<Comment>();
  @Output() resolveThread = new EventEmitter<void>(null);

  commentData$ = signal<Comment>(null);

  faCircleCheck = faCircleCheck;
  faSend = faSend;

  control = new FormControl(null, [Validators.required]);

  @Input() set comment(comment: Comment) {
    this.commentData$.set(comment);
  }

  onEmitHashtag(hashtag: string): void {
    this.emitHashtag.emit(hashtag);
  }

  onPostCommentReply(): void {
    if (this.control.valid) {
      const newReply = new Comment('', '', new Date(), '', this.commentData$().commentType, this.control.value, this.commentData$().id);
      this.control.reset();
      this.postComment.emit(newReply);
    }
  }

  onSaveComment(): void {
    if (this.control.valid) {
      this.commentData$().commentText = `${this.control.value} ${this.commentData$().sourceReferenceId}`;
      this.commentData$().sourceReferenceId = '';
      this.control.reset();
      this.saveChangesComment.emit(this.commentData$());
    }
  }
}
